<template>
  <div>
    <v-data-table :headers="headers" :items="maksimumSubmissionsItems" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Settings Maksimum Submissions</v-toolbar-title>
        </v-toolbar>
      </template>
      <template v-slot:item.no="{ item }">
        {{(maksimumSubmissionsItems.indexOf(item)+1) + '.'}}
      </template>
      <template v-slot:no-data>
        <span class="text-center">No data available.</span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" @click="editItem(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Jumlah Maksimum Submission</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <v-text-field v-model="editedItem.jumlah_maksimum" label="Jumlah Maksimum" required></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()">Tidak</v-btn>
          <v-btn color="blue darken-1" text @click="save()">Ya</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import itemTemplate from '@/components/ItemTemplate.vue';
export default {
  data: () => ({
    itemTemplate,
    dialog: false,
    expand: false,
    role: '',
    permission: [],
    showError: false,
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no"
      },
      {
        text: "Type",
        align: "left",
        value: "type"
      },
      { text: "Kategori", align: "center", value: "categories_name" },
      { text: "Jumlah Maksimum Pending", align: "center", value: "jumlah_maksimum" },
      { text: "Actions", align: "center", value: "action", sortable: false }
    ],
    maksimumSubmissionsItems: [],
    default_items: [],
    item: '',
    // selected: '',
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
  }),

  computed: {
    ...mapGetters({
    }),
    
    formTitle() {
      return this.editedIndex === -1 ? "Buat Item" : "Edit Item";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      getMaksimumSubmissions: "user/getMaksimumSubmissions",
      updateMaksimumSubmissionsItems: "user/updateMaksimumSubmissionsItems",
    }),
    async initialize() {
      const userLogin = JSON.parse(window.localStorage.getItem('user_data'))
      this.role = userLogin.roles[0].name
      this.permission = userLogin.permissions
      const dataItem = await this.getMaksimumSubmissions()
      // console.log('dataItem', dataItem)

      await forEach(dataItem.data.attributes, data => {
        // this.default_items.push(data)
        this.maksimumSubmissionsItems.push(data)
      })
    }, 

    setLabel (item) {
      return item.item_name;
    },

    editItem(data) {
      this.editedIndex = this.maksimumSubmissionsItems.indexOf(data)
      this.editedItem = Object.assign({}, data)
      this.dialog = true
      // console.log('this.item_items', this.item_items)
    },

    // async deleteItem(item) {
    //   const index = this.item_products.indexOf(item);
    //   if(confirm("Apakah anda yakin menghapus item ini?")){
    //      await this.deleteProducts(item.id)
    //      this.item_products.splice(index, 1);
    //   }
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async save() {
      if (this.editedIndex > -1) {
        try{
          // console.log(this.editedItem, 'this.editedItem')
          const response = await this.updateMaksimumSubmissionsItems(this.editedItem)
          // response.data.attributes[0].harga_beli = Number(response.data.attributes[0].harga_beli)
          // response.data.attributes[0].harga_jual = Number(response.data.attributes[0].harga_jual)
          Object.assign(this.maksimumSubmissionsItems[this.editedIndex], response.data.attributes[0])
        }catch(e){
          console.log(e)
        }
      } else {
        // console.log('this.selected', this.selected)
        // const response = await this.createProducts(this.editedItem)
        // response.data.attributes.harga_beli = Number(response.data.attributes.harga_beli)
        // response.data.attributes.harga_jual = Number(response.data.attributes.harga_jual)
        // this.maksimumSubmissionsItems.splice(0, 0, response.data.attributes)
      }
      this.close();
    }
  }
};
</script>
<style>
.vue-suggestion .vs__input {
    width: 100%;
    text-align: left;
    border-bottom: 1px solid black;
    max-height: 400px;
    overflow-y: auto;
    font-size: 16px;
    color: black;
    position: relative;
}
.vue-suggestion .vs__list {
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 400px;
    overflow-y: auto;
    border-bottom: 1px solid #023d7b;
    position: relative;
}
.vue-suggestion .vs__list .vs__list-item {
    position: relative;
    z-index: 1;
    background-color: #fff;
    padding: 10px;
    border-left: 1px solid #023d7b;
    border-right: 1px solid #023d7b;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
    border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
    background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
    position: absolute;
}
.vue-suggestion .vs__list .vs__list-item {
    cursor: pointer;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
    background-color: #f3f6fa;
}
</style>